'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keyMirror = require('react-utils/keyMirror');

var _keyMirror2 = _interopRequireDefault(_keyMirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// To help with flow configuration

var signupProducts = (0, _keyMirror2.default)({
  MARKETING: null, // any tier
  MARKETING_TRIAL: null,
  MARKETING_FREE: null,
  MARKETING_STARTER: null,
  MARKETING_PRO: null,
  SALES: null, // any tier
  SALES_FREE: null,
  SALES_STARTER: null,
  SALES_PRO: null,
  CRM: null,
  DEVELOPERS: null,
  ACADEMY: null,
  HUBSPOT_FOR_STARTUPS: null,
  SERVICE: null,
  TRIAL: null,
  PARTNER_CLIENT_SIGNUP: null,
  SALES_PARTNER: null,
  CHECKOUT_SIGNUP: null,
  STANDALONE_CMS_PARTNER: null,
  DIRECTORY_USER: null,
  STANDALONE_CMS_DEVELOPER: null
});

exports.default = signupProducts;
module.exports = exports['default'];